import {
  TEXT_COMPARISONS,
  TEXT_COLLECTION_COMPARISONS,
  DATE_COMPARISONS,
  NUMBER_COMPARISONS,
  BOOLEAN_COMPARISONS,
  DEFAULT_COMPARISONS,
  ATTR_TYPE_DATE,
  ATTR_TYPE_NUMBER,
  ATTR_TYPE_TEXT,
  ATTR_TYPE_TEXT_COLLECTION,
  ATTR_TYPE_BOOLEAN,
} from 'pages/RolesAndPermissions/consts';
import { SelectInputOption } from 'pages/RolesAndPermissions/molecules/Filters/valueInput/SelectInput';
import comparisonToDisplayName from 'pages/RolesAndPermissions/helpers/comparisonToDisplayName';

const fieldTypeToOptions: { [fieldType: string]: string[] } = {
  [ATTR_TYPE_TEXT]: TEXT_COMPARISONS,
  [ATTR_TYPE_TEXT_COLLECTION]: TEXT_COLLECTION_COMPARISONS,
  [ATTR_TYPE_DATE]: DATE_COMPARISONS,
  [ATTR_TYPE_NUMBER]: NUMBER_COMPARISONS,
  [ATTR_TYPE_BOOLEAN]: BOOLEAN_COMPARISONS,
};

function getComparisonOptions(fieldType: string): SelectInputOption[] {
  const comparisonOptions = fieldTypeToOptions[fieldType] || DEFAULT_COMPARISONS;

  return comparisonOptions.map(comparison => ({
    value: comparison,
    displayName: comparisonToDisplayName(comparison, fieldType),
  }));
}

export default getComparisonOptions;
